/*
 * Public API Surface of angular-firebase-authorizator
 */

export * from './lib/classes/permission-obj';
export * from './lib/classes/resource-obj';
export * from './lib/classes/role-obj';
export * from './lib/classes/user-obj';
export * from './lib/authorizator.config';
export * from './lib/components/angular-firebase-authotizator/angular-firebase-authotizator.component';
export * from './lib/services/authorizator.service';
export * from './lib/angular-firebase-authorizator.module';
